import { middlewareController } from '../middlewareController'

export const userApi = middlewareController.create.axiosInstance({
  baseURL: `${process.env.REACT_APP_AUTH_ENDPOINT}users`
})
